import { useEffect, useState, useRef } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from "@mui/icons-material/Error";
import {
  IDropDownList,
  IHandleChangeSearchList,
  IHandleClickVisibleList,
  IOptionDropDownList,
} from "../../../interfaces/IDropDownList";
import { ICategoriesValidationInput } from "../../../interfaces/IInput";

interface IFieldValues {
  value: IOptionDropDownList | undefined;
  valid: boolean;
}

export default (props: IDropDownList) => {
  const {
    list,
    summary,
    required,
    layer,
    onPermaValues,
    onPropertyChange,
    onValueChange,
    placeholder,
    layerLeft,
    errorPosition,
    disabled,
    defaultValue,
    requerido,
    datoRequerido,
    error,
    fieldError,
    onSearch,
    onScrollEnd,
    loadingMore,
  } = props;
  const [dropDownListActive, setDropdownListActive] = useState<boolean>(false);
  const [options, setOptions] = useState<IOptionDropDownList[]>([]);
  const [optionSelected, setOptionSelected] = useState<
    IOptionDropDownList | null | undefined
  >(null);
  const [enabledSearch, setEnabledSearch] = useState<boolean>(false);
  const refDropDownListCustomized = useRef<any>();
  const containerRef = useRef<HTMLDivElement>(null);
  const overflowRef = useRef<HTMLDivElement>(null);
  const searchTimeoutRef = useRef<ReturnType<typeof setTimeout>>();
  const [directionCollapse, setDirectionCollapse] = useState<
    string | undefined
  >(undefined);

  const [triggerError, setTriggerError] = useState<boolean>(false);
  const [triggerRequerido, setTriggerRequerido] = useState<boolean>(false);
  const [eventValidation, setEventValidation] = useState<string>("initial");
  const [categoriesValidation] = useState<ICategoriesValidationInput | any>({
    success: "input-success",
    error: "input-error",
    initial: "input-initial",
    caution: "input-caution",
  });
  const [inUseDropDownList, setInUseDropDownList] = useState<boolean>(false);

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setDropdownListActive(false);
      }
    };
    document.addEventListener("mousedown", handleMouseDown);
    window.addEventListener("scroll", handleEventScrollWindow);
    window.addEventListener("resize", handleEventReziseWindow);

    return () => {
      document.removeEventListener("mousedown", handleMouseDown);
      window.removeEventListener("scroll", handleEventScrollWindow);
      window.removeEventListener("resize", handleEventReziseWindow);
      clearTimeout(searchTimeoutRef.current);
    };
  }, []);

  useEffect(() => {
    if (list) {
      setOptions([...list]);
    }
  }, [list]);

  useEffect(() => {
    if (defaultValue) {
      setOptionSelected(defaultValue);
    }
  }, [defaultValue]);

  useEffect(() => {
    if (datoRequerido) {
      if (requerido) {
        setTriggerRequerido(true);
        setEventValidation("caution");
      } else {
        setTriggerRequerido(false);
        setEventValidation("success");
      }
    }
  }, [requerido, defaultValue]);

  useEffect(() => {
    if (!dropDownListActive) {
      setOptions([...list]);
      setEnabledSearch(false);
      if (onSearch) {
        clearTimeout(searchTimeoutRef.current);
        onSearch("");
      }
    }
  }, [dropDownListActive]);

  useEffect(() => {
    if (inUseDropDownList) {
      if (required) {
        if (optionSelected) {
          setEventValidation("success");
          setTriggerError(false);
        } else {
          setEventValidation("error");
          setTriggerError(true);
        }
      }

      if (!required) {
        if (optionSelected) {
          setEventValidation("success");
        } else {
          setEventValidation("initial");
        }
      }

      if (requerido && datoRequerido) {
        if (optionSelected) {
          setEventValidation("success");
          setTriggerRequerido(false);
          setTriggerError(false);
          setTriggerRequerido(false);
        } else {
          setEventValidation("caution");
          setTriggerError(false);
          setTriggerRequerido(true);
        }
      }
    }
  }, [inUseDropDownList, optionSelected, dropDownListActive]);

  const handleEventScrollWindow = () => {
    handleEventDirectionDropDownList();
  };

  const handleEventReziseWindow = () => {
    handleEventDirectionDropDownList();
  };

  const handleClickVisibleList = (events: IHandleClickVisibleList) => {
    const { show } = events;

    if (!show) {
      handleEventDirectionDropDownList();
    }

    setInUseDropDownList(true);
    setDropdownListActive(show ? false : true);
  };

  /*
   * TODO: Eliminar condicional if si el compoennte no funca seññoooor
   **/

  const handleEventDirectionDropDownList = () => {
    try {
      const boxDropDownList = refDropDownListCustomized.current;
      if (boxDropDownList !== null) {
        const { height, top } = boxDropDownList.getBoundingClientRect();
        const { outerHeight } = window;

        setDirectionCollapse(
          top + 200 + height > outerHeight - height
            ? "apply-collapse-top"
            : undefined
        );
      }
    } catch (error) {
      console.log("Error en dropdownlist", error);
    }
  };

  const handleChangeSearchList = (values: IHandleChangeSearchList) => {
    const { value } = values;
    setEnabledSearch(value !== "");

    if (onSearch) {
      clearTimeout(searchTimeoutRef.current);
      searchTimeoutRef.current = setTimeout(() => onSearch(value), 400);
    } else {
      const filters = list.filter(({ name }) =>
        name.toLocaleLowerCase().includes(value.toLocaleLowerCase())
      );
      setOptions(filters);
    }
  };

  const handleScrollOverflow = () => {
    if (!overflowRef.current || !onScrollEnd || loadingMore) return;
    const { scrollTop, scrollHeight, clientHeight } = overflowRef.current;
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      onScrollEnd();
    }
  };

  const handleClickSelectedOption = (values: IOptionDropDownList) => {
    setOptionSelected(values);
    setDropdownListActive(false);
    handleChangeExternalValue({ value: values, valid: true });
  };

  const handleClickDeletedOptionSelected = () => {
    setOptionSelected(null);
    handleChangeExternalValue({ value: undefined, valid: !required });
  };

  const handleChangeExternalValue = (prompt: IFieldValues) => {
    const { value, valid } = prompt;
    if (onPermaValues && onValueChange && onPropertyChange) {
      if (typeof onPropertyChange === "string") {
        const permaValues = { ...onPermaValues };
        permaValues[onPropertyChange] = {
          value,
          valid,
        };
        onValueChange(permaValues);
      }
      if (typeof onPropertyChange === "object") {
        const permaValues = [...onPermaValues];
        const [position, key] = onPropertyChange;
        permaValues[position][key] = {
          value,
          valid,
        };
        onValueChange(permaValues);
      }
    }
  };

  return (
    <div
      className={`${required ? "cols-required" : "cols-not-required"}`}
      style={layerLeft ? { display: "flex" } : {}}
    >
      <div style={layerLeft ? { display: "flex" } : {}}>
        {layer && (
          <label className="layer">
            {layer} {summary && <i>{summary}</i>}
          </label>
        )}
        {triggerError && ["up", undefined].includes(errorPosition) && (
          <span className="layer-error">es obligatorio</span>
        )}
        {triggerRequerido && ["up", undefined].includes(errorPosition) && (
          <span className="layer-caution">
            <ErrorIcon />
            Dato Requerido
          </span>
        )}
      </div>

      <div
        ref={containerRef}
        className={`dropdownlist-customized-box ${
          dropDownListActive
            ? "ddl-customized-box-show"
            : "ddl-customized-box-hidden"
        }`}
        style={fieldError ? { boxShadow: "0 0 0 1px #ef4444", borderRadius: "8px", transition: "box-shadow 0.2s" } : undefined}
      >
        <input
          ref={refDropDownListCustomized}
          placeholder={placeholder ?? "Seleccione"}
          className={`input-dropdownlist-customized ${
            error ? "input-error" : categoriesValidation[eventValidation]
          } ${
            dropDownListActive
              ? "input-ddl-customized-show"
              : "input-ddl-customized-hidden"
          } ${disabled && "disabled"}`}
          readOnly={true}
          onClick={() => handleClickVisibleList({ show: dropDownListActive })}
          value={optionSelected?.name ?? ""}
          disabled={disabled}
        />

        <div className="ddl-icons-options-list">
          {optionSelected?.code && (
            <>
              <button
                onClick={handleClickDeletedOptionSelected}
                className="button-delete-list-options"
                disabled={disabled ?? false}
              >
                <CloseIcon className="icon-delete-list-options" />
              </button>
              <span className="clear-box"></span>
            </>
          )}
          <button
            className={`button-showhidden-list-option ${
              error ? "input-error" : categoriesValidation[eventValidation]
            } ${disabled && "disabled"}`}
            onClick={() => {
              refDropDownListCustomized.current.focus();
              handleClickVisibleList({ show: dropDownListActive });
            }}
            disabled={disabled ?? false}
          >
            <KeyboardArrowDownIcon className="arrow-list" />
          </button>
        </div>

        {/* <div style={{display: "flex", position: "absolute"}}>
          <ButtonIcon>
            <AddIcon />
          </ButtonIcon>
        </div> */}
        {dropDownListActive && (
          <div
            className={`dropdownlist-customized-list ${directionCollapse}`}
          >
            <div
              className={`ddl-customized-search ${
                error ? "input-error" : categoriesValidation[eventValidation]
              }`}
            >
              <input
                placeholder="Buscar"
                className="input-initial"
                onChange={({ target }) =>
                  handleChangeSearchList({ value: target.value })
                }
              />
              {enabledSearch && (
                <button
                  onClick={() => handleChangeSearchList({ value: "" })}
                  className="button-delete-search"
                  disabled={disabled ?? false}
                >
                  <CloseIcon className="icon-delete-search" />
                </button>
              )}
            </div>
            <div
              ref={overflowRef}
              className="ddl-customized-overflow"
              onScroll={handleScrollOverflow}
            >
              {options.map(({ name, code }, key) => (
                <div
                  key={key}
                  className={`ddl-customized-list-option ${
                    optionSelected?.code === code &&
                    "ddl-customized-list-option-selected"
                  }`}
                  onClick={() => handleClickSelectedOption({ name, code })}
                >
                  {optionSelected?.code !== code ? (
                    <RadioButtonUncheckedIcon />
                  ) : (
                    <RadioButtonCheckedIcon />
                  )}{" "}
                  {name}
                </div>
              ))}
              {options.length == 0 && !loadingMore && (
                <div className="ddl-customized-option-not-data">
                  {enabledSearch ? (
                    <>No he encontrado resultados</>
                  ) : (
                    <>Sin resultados que mostrar</>
                  )}
                </div>
              )}
              {loadingMore && (
                <div className="ddl-customized-option-not-data">
                  Cargando más...
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      {triggerError && errorPosition === "down" && !disabled && (
        <span className="layer-error down">Dato obligatorio</span>
      )}

      {triggerRequerido && errorPosition === "down" && !disabled && (
        <span className="layer-caution down">
          <ErrorIcon />
          Dato Requerido
        </span>
      )}
    </div>
  );
};
